import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { ErrorEventsClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.EventoErrQuery],
});

export const headCells: HeadCell<ErrorEventsClient, keyof ErrorEventsClient>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'dataTime',
    label: 'Data ora',
  },
  {
    id: 'typeEventCode',
    label: 'Tipo Evento',
  },
  {
    id: 'eventDescription',
    label: 'Descrizione Tipo Evento',
  },
  {
    id: 'subscriber',
    label: 'Sottoscrittore',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaErrorEventsFilter = yup.object({
  id: yup.number(),
  dateTimePublicationFrom: yup.date().nullable().typeError('Data non valida'),
  dateTimePublicationTo: yup.date().nullable().typeError('Data non valida'),
});
